import React from "react";
import { Link } from "react-router-dom";
import { isAdmin } from "../utils";
import "./SettingsContent.css";

const SETTINGS_GRID_ITEMS = [
  { to: "/cms/settings/general", label: "General", icon: "fa-gears", adminOnly: true },
  { to: "/cms/settings/slideshow", label: "Slideshow", icon: "fa-image", adminOnly: true },
  { to: "/cms/about", label: "About", icon: "fa-info" },
  { to: "/cms/testimonials", label: "Testimonials", icon: "fa-quote-left", adminOnly: true },
  { to: "/cms/languages", label: "Languages", icon: "fa-language", adminOnly: true },
  { to: "/cms/translations", label: "Translations", icon: "fa-book", adminOnly: true },
  { to: "/cms/countries", label: "Countries", icon: "fa-map-marker" },
  { to: "/cms/notifications", label: "Notifications", icon: "fa-bell", adminOnly: true },
  { to: "/cms/faqs", label: "FAQ", icon: "fa-question-circle" },
  { to: "/cms/popupmessages", label: "Popup Message", icon: "fa-comment" },
  { to: "/cms/banned", label: "Banned", icon: "fa-ban", adminOnly: true },
  { to: "/cms/pages", label: "Pages", icon: "fa-list", adminOnly: true },
  { to: "/cms/videogallerylist", label: "Video Gallery", icon: "fa-play" },
];

export default function SettingsContent() {
  const visibleItems = SETTINGS_GRID_ITEMS.filter(
    (item) => !item.adminOnly || isAdmin()
  );

  return (
    <div className="content-wrapper">
      
      <section className="content">
        <div className="container-fluid" style={{ maxWidth: "1400px" }}>
          <div className="row users-filter-page-row">
            <div className="col-md-12 users-filter-page-col">
              <div className="box box-primary mt-0 border-top-0">
                <div className="box-header with-border mb-4">
                  <h3 className="box-title">Settings</h3>
                </div>
                <div className="box-body">
                  <div className="settings-grid">
                    {visibleItems.map((item, index) => (
                      <Link
                        to={item.to}
                        key={item.to}
                        className="settings-grid-card"
                        style={{ animationDelay: `${index * 80}ms` }}
                      >
                        <span className="settings-grid-icon">
                          <i className={`fa ${item.icon}`} />
                        </span>
                        <span className="settings-grid-label">{item.label}</span>
                        <span className="settings-grid-arrow">
                          <i className="fa fa-angle-right" />
                        </span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
